/* Version: 3.5.137 */
'use client';
import 'react';
import { jsxs, jsx } from 'react/jsx-runtime';

var chevronDownIcon = (function (_ref) {
  var alt = _ref.alt;
  return /*#__PURE__*/jsxs("svg", {
    width: "20px",
    height: "20px",
    focusable: "false",
    viewBox: "0 0 28 20",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    children: [/*#__PURE__*/jsx("title", {
      children: alt
    }), /*#__PURE__*/jsx("g", {
      stroke: "none",
      strokeWidth: "1",
      fill: "none",
      fillRule: "evenodd",
      children: /*#__PURE__*/jsx("g", {
        transform: "translate(-236.000000, -16.000000)",
        fill: "#34384B",
        fillRule: "nonzero",
        children: /*#__PURE__*/jsx("g", {
          transform: "translate(235.000000, 7.000000)",
          children: /*#__PURE__*/jsx("path", {
            d: "M24.863961,4.63603897 L25,4.63603897 L25,11.636039 L24.863961,11.636039 L24.863961,24.5 L17.863961,24.5 L17.863961,11.636039 L5,11.636039 L5,4.63603897 L17.863961,4.63603897 L17.863961,4.5 L24.863961,4.5 L24.863961,4.63603897 Z",
            transform: "translate(15.000000, 14.500000) rotate(-225.000000) translate(-15.000000, -14.500000) "
          })
        })
      })
    })]
  });
});

export { chevronDownIcon as default };
